// share okna
function share() {
  // otevření okna
  Array.from(document.getElementsByClassName('js-share-open')).forEach((element) => {
    element.addEventListener('click', function (event) {
      event.stopPropagation();
      event.preventDefault();
      // Remove 'is-open' class from all elements with the class 'share'
      Array.from(document.getElementsByClassName('share')).forEach((shareElement) => {
        shareElement.classList.remove('is-open');
      });
      // otevření okna
      this.nextElementSibling.classList.add('is-open');
    });
  });

  // zavření share okna
  Array.from(document.getElementsByClassName('js-share-close')).forEach((element) => {
    element.addEventListener('click', function (event) {
      event.preventDefault();
      this.closest('.share').classList.remove('is-open');
    });
  });

  // zamezení zavření po kliknutí na tělo share
  Array.from(document.getElementsByClassName('share')).forEach((element) => {
    element.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
  });

  document.querySelectorAll('[data-id="share-btn"]').forEach((button) => {
    const link = button.closest('.share').getAttribute('data-link');
    const btnType = button.getAttribute('data-type');
    let url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`;
    if (btnType === 'x') {
      url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(link)}`;
    }
    button.addEventListener('click', function () {
      window.open(url, '_blank');
    });
  });

  document.querySelectorAll('[data-id="copy-btn"]').forEach((copyButton) => {
    copyButton.addEventListener(
      'click',
      function () {
        const container = copyButton.closest('.share__content');
        const linkInput = container.querySelector('input');
        if (navigator.clipboard) {
          console.log('clipboard supported');
          navigator.clipboard.writeText(linkInput.value);
        } else {
          console.log('clipboard not supported');
          linkInput.select();
          document.execCommand('copy');
        }
      },
      { once: true }
    );
  });
}
